import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    user: {},
    token: '',
    ifCompose: false,// 当前编辑状态
    patient: {},
    systemInfo: {},
    ifShowZiwai: false,
    language: ''
  },

  mutations: {
    updateUser(state, data) {
      state.user = data;
      localStorage.setItem('user', JSON.stringify(data));
    },
    updateToken(state, token) {
      state.token = token;
      localStorage.setItem('token', token);
    },
    updateIfCompose(state, ifCompose) {
      state.ifCompose = ifCompose;
    },
    updatePatient(state, data) {
      state.patient = data;
    },
    updateSystemInfo(state, data) {
      state.systemInfo = data;
    },
    updateIfShowZiwai(state, data) {
      state.ifShowZiwai = data;
    },
    updateLanguage(state, data) {
      state.language = data;
    },
  }
});

export default store;
